import Image from "next/image";
import Link from "next/link";
import { useState, useEffect } from "react";

import { useAppContext } from "@/context/Context";
import { useRouter } from "next/router";
import emoji from "../../../public/images/icons/hand-emojji.svg";
import RoleSelectionModal from "@/components/Modal/loginModal";
import styles from "./HeaderTopBar.module.css";

const HeaderTopBar = ({
  bgColor,
  gapSpaceBetween,
  container,
  flexDirection,
}) => {
  const router = useRouter();
  const { toggle, setToggle } = useAppContext();
  const [showMobilePopup, setShowMobilePopup] = useState(false);
  const [isHeaderClosed, setIsHeaderClosed] = useState(false);
  const [showModal, setShowModal] = useState(false);


  const referralCode = router.query.ref || null;

  useEffect(() => {
    const checkMobile = () => {

      const popupClosed = sessionStorage.getItem('mobilePopupClosed');

      if (window.innerWidth <= 767 && !popupClosed) {
        setShowMobilePopup(true);
      } else {
        setShowMobilePopup(false);
      }
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  useEffect(() => {
    if (referralCode && router.pathname === '/') {
      setShowModal(true);
    }
  }, [referralCode, router.pathname]);

  const closeMobilePopup = () => {
    setShowMobilePopup(false);
    sessionStorage.setItem('mobilePopupClosed', 'true');
  };

  const closeHeaderTop = () => {
    setIsHeaderClosed(true);
  };

  const handleRegisterNowClick = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  if (isHeaderClosed) {
    return null;
  }

  return (
    <>
      <RoleSelectionModal
        isOpen={showModal}
        onClose={closeModal}
        type="register"
        referralCode={referralCode}
      />

      {showMobilePopup && (
        <div className="mobilePopup">
          <button className="popupClose" onClick={closeMobilePopup}>
            ×
          </button>

          <div className="popupBadge">🔥 Super Hot Offer</div>

          <div className="popupText">
            <Image src={emoji} alt="Hand Emojji" className="popupEmoji" />
            Intro price! First 100 Registration (Instructors) for free.
          </div>

          <button className="popupButton" onClick={handleRegisterNowClick}>
            Register Now →
          </button>
        </div>
      )}

      <div
        className={`rbt-header-campaign rbt-header-campaign-1 rbt-header-top-news rbt-header-top rbt-header-top-1 bg-image1 ${gapSpaceBetween} ${bgColor} top-expended-activation d-none d-lg-block ${!toggle ? "d-none" : ""
          }`}
        style={{
          minHeight: "30px",
          paddingTop: "5px",
          paddingBottom: "5px",
          fontSize: "12px",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          width: "100%",
          zIndex: 9999,
        }}
      >
        <div className={`${container}`}>
          <div className="top-expended-wrapper">
            <div
              className={`top-expended-inner rbt-header-sec align-items-center justify-content-center ${flexDirection}`}
            >
              <div className="rbt-header-content d-flex align-items-center justify-content-center">
                <div className="header-info d-flex align-items-center">
                  <span className="rbt-badge variation-02 bg-color-primary color-white radius-round">
                    🔥 Super Hot Offer
                  </span>
                  &nbsp;
                  <span
                    className="news-text d-flex align-items-center me-3"
                    style={{ color: "white" }}
                  >
                    <Image
                      src={emoji}
                      width={22}
                      height={22}
                      alt="Hand Emojji Images"
                      className="me-2"
                    />
                    Intro price! First 100 Registration for free.
                  </span>
                  <div className="right-button">
                    <Link
                      className={`rbt-btn-link ${styles.registerNow}`}
                      href="#"
                      onClick={handleRegisterNowClick}
                    >
                      <span className="color-white">
                        Register Now{" "}
                        <i className="feather-arrow-right ms-1"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>

              <button
                onClick={closeHeaderTop}
                className="btn-close-header position-absolute"
                aria-label="Close header banner"
                style={{
                  top: "50%",
                  right: "15px",
                  transform: "translateY(-50%)",
                  background: "transparent",
                  border: "none",
                  color: "white",
                  fontSize: "18px",
                  cursor: "pointer",
                  padding: "5px",
                  borderRadius: "3px",
                  transition: "all 0.2s ease",
                  zIndex: 10,
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                }}
              >
                ×
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderTopBar;
